import Test from "./Test";
export default class WorkflowSearchSmokeTest extends Test {
  constructor(api) {
    super(api, "Workflow Search Smoke Test");
  }

  async init() {
    try {
      // Fetch all workflows
      const response = await this.api.get("/workflow");
      // Prepare test cases for each workflow
      return response
        .filter(
          wf =>
            Array.isArray(wf.searchable_fields) &&
            wf.searchable_fields.length > 0
        )
        .map(wf => {
          let label = wf.label || wf.slug;
          return {
            name: `Workflow Test: ${label || "[Unnamed]"}`,
            slug: wf.slug,
            label: label,
            link: this.api.host.replace("/api", "") + "/workflow/" + wf.slug,
            searchable_fields: wf.searchable_fields || []
          };
        });
    } catch (error) {
      // Handle error gracefully
      throw new Error("Failed to load workflows. Error: " + error.message);
    }
  }

  async exec(test) {
    let label = test.label || test.slug;
    // Fetch objects for the workflow
    let baseRoute = test?.slug?.includes("__MOBILE__")
      ? "/mobile/workflow/" + test.slug.replace("__MOBILE__", "")
      : "/workflow/" + test.slug;

    let route = `${baseRoute}/objects`;
    let res = await this.api.get(route, {
      limit: 1,
      fields: "all"
    });
    if (res.error || !res.items || !res.items.length) {
      return {
        success: false,
        message: `Failed to load objects for workflow ${label}. Error: ${res?.error ? res?.error?.data?.message : "No Records Found"}`
      };
    }
    // For each searchable field, try searching once with the value from the first record test is done
    let searchFields = test?.searchable_fields || [];
    for (let searchField of searchFields) {
      let searchValue = res.items[0].items
        ? res.items[0].items[0][searchField]
        : res.items[0][searchField];
      if (typeof searchValue === "object") {
        searchValue =
          searchValue?.label || searchValue?.value || searchValue?.[0];
      }

      if (!searchValue) {
        continue;
      }

      // ---- Autocomplete check ----
      let autocompleteRoute = `/workflow/${test.slug}/autocomplete?q=${encodeURIComponent(
        searchValue
      )}`;
      let autoRes = await this.api.get(autocompleteRoute);

      // If the autocomplete response is invalid, return an error
      if (autoRes?.error) {
        return {
          success: false,
          message: `Search failed for workflow ${label}. Error: ${
            autoRes?.error?.data?.message || "Unknown error"
          }`
        };
      }
      if (!autoRes.length) {
        continue;
      }
      let searchData = autoRes?.[0];
      // If the search values is an object, it is invalid
      if (typeof searchData.title === "object") {
        return {
          success: false,
          message: `Search for workflow ${label} returned invalid title/value (object instead of string). Data: ${JSON.stringify(
            searchData
          )}`
        };
      }
      break;
    }

    return res.error
      ? {
          success: false,
          message: `Failed to load objects for workflow ${label}. Error: ${res?.error?.data?.message}`
        }
      : {
          success: true,
          message: `Workflow ${label} passed successfully.`
        };
  }
}
